@if (type) {
  <div class="my-3 p-3 rounded-lg prose dark:prose-invert !max-w-none" [class]="alertClass">
    <ng-content></ng-content>
  </div>
}
